import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Play } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const bannerImg = (url) => (url?.startsWith("/api/") ? `${BACKEND}${url}` : url);

export const BannerHero = ({ banners }) => {
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const banner = banners[idx] || null;

  useEffect(() => {
    if (banners.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % banners.length), 8000);
    return () => clearInterval(t);
  }, [banners.length]);

  if (!banner) return null;

  const handlePlay = () => {
    if (banner.action) return banner.action();
    if (banner.link_type === "vod" && banner.link_value) navigate(`/app/player/vod/${banner.link_value}`, { state: { returnPath: location.pathname } });
    else if (banner.link_type === "live" && banner.link_value) navigate("/app/live", { state: { channelId: banner.link_value } });
    else if (banner.link_type === "url" && banner.link_value) window.open(banner.link_value, "_blank");
  };

  const showButton = banner.action || (banner.link_type && banner.link_type !== "none" && banner.link_value);
  const buttonLabel = banner.action_label || (banner.link_type === "live" ? "İzlə" : "Oynat");

  return (
    <div data-testid="server-banner-hero" className="relative h-[280px] sm:h-[360px] md:h-[420px] overflow-hidden">
      <img key={banner.id} src={bannerImg(banner.image_url)} alt="" className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#09090b] via-[#09090b]/70 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#09090b] via-transparent to-[#09090b]/30" />

      <div className="relative z-10 h-full flex flex-col justify-end p-5 sm:p-6 md:p-8 max-w-xl">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 leading-tight">{banner.title}</h1>
        {banner.description && <p className="text-sm text-zinc-400 mb-5 line-clamp-2">{banner.description}</p>}
        {showButton && (
          <div className="flex gap-3">
            <button
              data-testid="banner-hero-play-btn"
              onClick={handlePlay}
              className="flex items-center gap-2 px-6 py-2.5 bg-white text-black font-semibold rounded-lg hover:bg-zinc-200 transition-colors text-sm w-fit"
            >
              <Play className="w-4 h-4" fill="currentColor" /> {buttonLabel}
            </button>
          </div>
        )}
      </div>

      {banners.length > 1 && (
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {banners.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-1.5 bg-white/40 hover:bg-white/70"}`}
              aria-label={`Banner ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
